import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";

import useScrollTrigger from "@mui/material/useScrollTrigger";
import Slide from "@mui/material/Slide";

import TemporaryDrawer from "./LeftNavDrawer";

import { cronicleSections } from "../config";
import { Box, styled } from "@mui/material";
import { StaticImage } from "gatsby-plugin-image";

const HideOnSmallScreen = styled(Box)(({ theme }) => ({
    [theme.breakpoints.down("sm")]: {
        display: "none",
    },
    display: "flex",
    width: "100%",
}));

interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
    children: React.ReactElement;
}

function HideOnScroll(props: Props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
    });

    return (
        <Slide appear={true} direction="down" in={trigger}>
            {children}
        </Slide>
    );
}

function Sections({ sections }: HeaderProps) {
    return (
        <>
            {sections.map((section) => (
                <Link
                    color="inherit"
                    key={section.title}
                    variant="button"
                    href={section.url}
                    sx={{
                        p: 1,
                        flexShrink: 0,
                        textTransform: "uppercase",
                        textDecoration: "none",
                    }}
                >
                    {section.title}
                </Link>
            ))}
        </>
    );
}

interface HeaderProps {
    sections: ReadonlyArray<{
        title: string;
        url: string;
    }>;
    title: string;
}

export default function Header(props: HeaderProps) {
    const { sections, title } = props;

    return (
        <React.Fragment>
            <HideOnScroll>
                <AppBar color="inherit">
                    <Toolbar
                        component="nav"
                        variant="dense"
                        sx={{
                            justifyContent: "space-between",
                            overflowX: "auto",
                        }}
                    >
                        <TemporaryDrawer />
                        <Link
                            href="/"
                            sx={{
                                flexGrow: 1,
                                flexShrink: 0,
                            }}
                        >
                            <StaticImage
                                src="../images/cronicle-logo.png"
                                alt="Cronicle Press Logo"
                                layout="fixed"
                                width={372 * 0.4}
                                height={80 * 0.4}
                            />
                        </Link>
                    </Toolbar>
                </AppBar>
            </HideOnScroll>
            <Toolbar variant="dense">
                <TemporaryDrawer />
                <HideOnSmallScreen>
                    {cronicleSections.map(({ title, url, flexGrow }) => (
                        <Link
                            color="inherit"
                            key={title}
                            variant="button"
                            href={url}
                            sx={{
                                p: 1,
                                flexGrow: flexGrow ? flexGrow : 0,
                                flexShrink: 0,
                                textTransform: "uppercase",
                                textDecoration: "none",
                            }}
                        >
                            {title}
                        </Link>
                    ))}
                </HideOnSmallScreen>
            </Toolbar>
            <Box sx={{
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                margin: 3,
            }}>
                <Link href="/">
                    <StaticImage
                        src="../images/cronicle-logo.png"
                        alt="Cronicle Press Logo"
                        layout="fixed"
                        imgStyle={{
                            objectFit: "contain"
                        }}
                        width={372}
                        height={80}
                    />
                </Link>

            </Box>

            <HideOnSmallScreen>
                <AppBar position="relative" color="inherit">
                    <Toolbar
                        component="nav"
                        variant="dense"
                        sx={{
                            justifyContent: "space-between",
                            overflowX: "auto",
                        }}
                    >
                        <Sections {...props} />
                    </Toolbar>
                </AppBar>
            </HideOnSmallScreen>
        </React.Fragment>
    );
}
